module.exports = __webpack_public_path__ + "img/far-lock-keyhole.9ea8685e.svg";